<template>
  <ModalDialog
    ref="dialog"
    :title="dialogTitle"
    submitTitle="Export"
    icon="fa-file-csv"
    sizeClass="modal-lg"
    @submitted="onSubmitted">

    <FormGroup :labelColumnSize="2">
      <FormRow label="Format">
        <FormStaticLabel>CSV</FormStaticLabel>
      </FormRow>
      <FormRow label="Headers">
        <FormCheckbox v-model="includeHeaders" />
      </FormRow>
      <FormRow label="Column Field">
        <FormOption :label="columnSeriesTitle" name="columnAxis" setting="series" v-model="columnAxisType"  /><br />
        <FormOption :label="columnXAxisTitle" name="columnAxis" setting="x" v-model="columnAxisType" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>

<script>
import _ from 'lodash'

import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import { saveAs } from 'file-saver'
import { CSVWriter } from '@/utils/csvUtils'

export default {
  name: 'ChartBarExportDialog',
  mixins: [
    modalDialog
  ],
  components: {
    ModalDialog
  },
  props: {
    title: {
      type: String,
      default: 'Chart'
    },
  },
  data() {
    return {
      series: [],
      xAxis: {},
      yAxis: {},
      legend: {},
      options: {},

      includeHeaders: true,
      columnAxisType: 'series'
    }
  },
  mounted() {
    
  },
  computed: {
    dialogTitle() {
      return `${this.title} Chart Export`
    },
    hasChartSeries() {
      if(this.series) {
        return this.series.some(series => {
          if(series.data && series.data.length > 0)
            return true
        })
      }
      return false
    },
    columnSeriesTitle() {
      var sampleText = ''
      if(_.isArray(this.series) && this.series.length > 0) {
        sampleText = `(${this.series.slice(0, 2).map(s => s.name).join(', ')}, ...)`
      }

      return `Series ${sampleText}`
    },
    columnXAxisTitle() {
      var sampleText = ''
      if(this.xAxis && _.isArray(this.xAxis.data) && this.xAxis.data.length > 0) {
        sampleText = `(${this.xAxis.data.slice(0, 2).join(', ')}, ...)`
      }

      return `X Axis ${sampleText}`
    }
  },
  methods: {
    show(params) {

      this.series = params.series
      this.xAxis = params.xAxis
      this.yAxis = params.yAxis
      this.legend = params.legend
      this.options = params.options || {}

      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      var csvWriter = new CSVWriter()

      csvWriter.exportHeaders = this.includeHeaders

      var xAxisData = this.xAxis.data
      if(_.isArray(this.xAxis.exportData) && this.xAxis.exportData.length > 0)
        xAxisData = this.xAxis.exportData

      // Series on the columns
      if(this.columnAxisType == 'series') {
        csvWriter.addColumn(this.xAxis.exportName || 'Data', 'xaxis')
        this.series.forEach((series, seriesIndex) => {
          csvWriter.addColumn(series.name, seriesIndex)
        })

        let rowList = xAxisData.map((xAxisValue, index) => {
          var row = {
            xaxis: xAxisValue,
            _lookupData: this.xAxis.data[index]
          }

          for(let i=0; i<this.series.length; i++) {
            row[i] = 0
          }

          return row
        })

        this.series.forEach((series, seriesIndex) => {
          for(let i=0; i<series.data.length; i++) {
            let seriesData = series.data[i]

            if(_.isArray(seriesData)) {
              let row = rowList.find(row => row._lookupData == seriesData[0])
              if(row)
                row[seriesIndex] = seriesData[1]

            } else {
              rowList[i][seriesIndex] = seriesData
            }
          }
        })

        rowList.forEach(row => {
          csvWriter.addRow(row)
        })

      } else {
        
        // xAxis for columns
        csvWriter.addColumn('Series', 'series')
        xAxisData.forEach((xAxisValue, index) => {
          csvWriter.addColumn(xAxisValue, index)
        })

        this.series.forEach((series, seriesIndex) => {
          var row = {
            series: series.name
          }

          for(let i=0; i<series.data.length; i++) {
            let seriesData = series.data[i]

            if(_.isArray(seriesData)) {
              let axisIndex = this.xAxis.data.findIndex(axisVal => axisVal == seriesData[0])
              if(axisIndex != -1)
                row[axisIndex] = seriesData[1]

            } else {
              row[i] = seriesData
            }
          }

          csvWriter.addRow(row)
        })
      }

      var csvBlob = new Blob([csvWriter.export()], {
        type: 'text/csv'
      });

      var filename = `chart-${this.dialogTitle.toLowerCase().trim().replaceAll(' ', '-')}.csv`
      
      saveAs(csvBlob, filename)

      this.modalClosed(true)
      this.hide()
    }
  }
}
</script>